import Script from 'next/script'

import type { BazaarvoiceScriptLoaderProps } from './types'

/**
 * `BazaarvoiceScriptLoader` — carga el script de Bazaarvoice correspondiente
 * al entorno actual (spec.md, contracts/bazaarvoice-integration.md).
 *
 * `strategy="afterInteractive"` (nunca `beforeInteractive`): la
 * puntuación/reseñas de producto son contenido que debe verse sin
 * interacción del usuario (FR-002/FR-006), así que no se gatea detrás de un
 * clic explícito como los widgets de soporte/utilidad del Principio X
 * (`Accessibility.tsx`) — ver plan.md, Complexity Tracking, para la
 * justificación completa de esta excepción.
 *
 * No requiere `'use client'`: `next/script` funciona en Server Components
 * salvo que se necesiten los callbacks `onLoad`/`onReady`/`onError`, que este
 * componente no usa — la observación del DOM vive aparte, en
 * `useBazaarvoiceRatingObserver`.
 */
export function BazaarvoiceScriptLoader({ scriptUrl }: BazaarvoiceScriptLoaderProps) {
  return <Script id="bazaarvoice-script" src={scriptUrl} strategy="afterInteractive" async />
}
